<template>
    <div :class="css">
        <div class="subheading">
            <div>
                <svg width="40px" height="2px" viewBox="0 0 40 2" version="1.1"
                     xmlns="http://www.w3.org/2000/svg"
                     xmlns:xlink="http://www.w3.org/1999/xlink">
                    <g stroke="none" stroke-width="2" fill="none" fill-rule="evenodd">
                        <g transform="translate(-20.000000, -916.000000)" fill="#fff">
                            <g transform="translate(20.000000, 904.000000)">
                                <g>
                                    <rect x="0" y="12" width="40" height="2"></rect>
                                </g>
                            </g>
                        </g>
                    </g>
                </svg>
            </div>
            <span class="h6 wysiwyg" v-html="item.subheading"/>
        </div>
        <h1 v-if="index == 0" class="hero-homepage__heading wysiwyg" v-html="item.heading" />
        <h2 v-else class="hero-homepage__heading wysiwyg" v-html="item.heading" />
        <a class="btn--hero"
           v-if="hasLink"
           :class="ctaLinkClass"
           :href="link.url"
           :target="getTarget"
           :rel="getRel"
           :title="item.cta_seo_title"
        >{{ link.title }}</a>
    </div>
</template>

<script>
export default {
    name: "heroHomepageContent",
    components: {},
    props: {
        index: Number,
        active: Boolean,
        item: Object,
        translations: Object,
        ctaLinkClass: String,
        debug: Boolean,
    },
    computed: {
        css() {
            return [
                'hero-homepage__container-content',
                this.active && 'hero-homepage__container-content--active',
            ]
        },
        link() {
            return this.item && this.item.cta_link || {};
        },
        hasLink() {
            return this.item && this.item.cta_link && this.item.cta_link !== '';
        },
        getTarget() {
            if (this.item.cta_link && this.item.cta_link !== '') {
                return this.item.cta_link.target || null;
            }
            return null;
        },
        getRel() {
            if (this.item.ctaLink && this.item.cta_link !== '') {
                const match = (new RegExp('rel="(.*)"', 'gi')).exec(this.item.cta_link.attributes);
                return match && match[1] || '';
            }
            return '';
        }
    }
}
</script>
